<script setup lang="ts"></script>

<template>
  <div class="AbsoluteVerticalCenter">
    <div class="flex flex-col align-items-center">
      <div>
        <h2>{{ $t('c.fullScreenLoading.loadingMessage') }}</h2>
      </div>
      <div><ProgressSpinner stroke-width="5"></ProgressSpinner></div>
    </div>
  </div>
</template>

<style scoped>
.AbsoluteVerticalCenter {
  margin: 50vh auto 0;
  transform: translateY(-50%);
}
</style>
